var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Routes, Route, Outlet, useLocation } from 'react-router-dom';
import { routes } from './routes';
import AppMainLayout from './layout/AppMainLayout';
// import NotFoundPage from '../../containers/NotFoundPage/Loadable';
import AppOverview from '../../containers/AppOverview/Loadable';
import 'react-toastify/dist/ReactToastify.css';
/**
 * Layout route wrapper
 * This MUST be part of the router tree in v6
 */
var LayoutWrapper = function () {
    var _a;
    var pathname = useLocation().pathname;
    var pathNameArray = pathname.split('/');
    var shouldHideRoutes = pathNameArray[5] === 'structure' || ((_a = pathNameArray[5]) === null || _a === void 0 ? void 0 : _a.length) === 19;
    return _jsx(AppMainLayout, { children: !shouldHideRoutes && _jsx(Outlet, {}) });
};
/**
 * Recursive route renderer
 */
var renderRoutes = function (routes) {
    return routes.map(function (_a) {
        var path = _a.path, PageComponent = _a.pageComponent, element = _a.element, children = _a.children;
        return (_jsx(Route, __assign({ path: path, element: PageComponent ? _jsx(PageComponent, {}) : element }, { children: children && renderRoutes(children) }), path));
    });
};
var AppBuilderSubRouter = function () {
    return (_jsx(Routes, { children: _jsxs(Route, __assign({ element: _jsx(LayoutWrapper, {}) }, { children: [renderRoutes(routes), _jsx(Route, { path: "*", element: _jsx(AppOverview, {}) })] })) }));
};
export default AppBuilderSubRouter;
